import React, { Component } from "react";

export class Address extends Component {
  constructor(props) {
    super(props);

    this.state = {};
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick = () => {
    if (window && window.gtag) {
      window.gtag("event", "get_direction_clicked", {
        event_label: "Get Direction Clicked",
      });
    }
    window.open(this.props.gmbLink, "_blank");
  };
  render() {
    return (
      <div className="footer-address-block">
        <p className="bold">{this.props.dealer}</p>
        <p>
          {this.props.address} <br />
          <a href={`tel:${this.props.contact}`}>{this.props.contact}</a>
          <br />
          {this.props.email && <a href={`mailto:${this.props.email}`} target="_blank">{this.props.email}</a> }
          <a href={`https://${this.props.website}`} target="_blank">
            {this.props.website}
          </a>
        </p>
        {
          this.props.gmbLink ? (
            <button
              className="btn btn-direction"
              id="btn-direction"
              type="button"
              onClick={this.handleClick}
            >
              Get Direction
            </button>
          ) : null
        }
      </div>
    );
  }
}

export default Address;
